import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';

import ReportProblemDialog from '../../Shared/Dialogs/ReportProblemDialog';

import RegisterMaterial from '../../Recycle/RegisterMaterial';
import WriteOffMaterial from '../../Recycle/WriteOffMaterial';
import { History, Recycle } from 'lucide-react';

export const RecyclePage = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    let history = useHistory();

    const [selectedTab, setSelectedTab] = useState("Stock");

    const [reportProblemDialogOpen, setReportProblemDialogOpen] = useState(false);
    const [notificationSubmissionLoading, setNotificationSubmissionLoading] = useState(false);

    useEffect(() => {
        // console.log(t("RECYCLE"));
        console.log("recycleprops", props);
    }, []);

    const handleTabSelection = (tab) => {
        setSelectedTab(tab);
    }

    const navigateToRecyclingHistory = () => {
        history.push('/recyclinghistory')
    }

    const openReportProblemDialog = () => {
        setReportProblemDialogOpen(true);
    }

    const submitProblemNotification = (problemDescription) => {
        console.log(notificationSubmissionLoading);
        setNotificationSubmissionLoading(true);
        const tempSelectedWorkstationId = props.workstation.selectedRecyclingWorkstationId;
        const tempSelectedWorkstationCode = props.workstation.activeRecyclingWorkstations.find(x => x.id === tempSelectedWorkstationId).code || null;

        // Parameters to pass: notificationTypeId: any, barcode: any, machineId: any, machineCode: any, sampleSequence: any, productionOrderRef: any, sampleId: any, sampleCode: any, systemMessageId: any, message: any
        dataService.saveNotification(0, null, tempSelectedWorkstationId, tempSelectedWorkstationCode, null, null, null, null, 0, problemDescription).then(() => {
            toast.success(t("Problem reported"), { position: "top-center" });
            setReportProblemDialogOpen(false);
            setNotificationSubmissionLoading(false);
        }).catch((error) => { toast.error(error, { position: "top-center" }) });
    }



    return (
        <>
            <div className={classes.container}>
                <div className={classes.header}>
                    <h1 className={classes.header__title}>
                        {t("Recyclage")}
                    </h1>
                    <div className={classes.tabSlider}>
                        <button onClick={() => handleTabSelection("Stock")} className={classes.tabSlider__Tab} style={{ color: selectedTab == "Stock" ? "#F8F8F8" : "#0C0E29" }}>{t("Stock")}</button>
                        <button onClick={() => handleTabSelection("Recycle")} className={classes.tabSlider__Tab} style={{ color: selectedTab == "Recycle" ? "#F8F8F8" : "#0C0E29" }}>{t("Recycle")}</button>
                        <div style={{ transform: selectedTab == "Stock" ? "translateX(0px)" : "translateX(144px)" }} className={classes.tabSlider__Indicator} />
                    </div>
                </div>
                <div className={classes.sideBar}>
                    <button onClick={() => navigateToRecyclingHistory()} className={classes.secondaryButton}>
                        <History size={24} />
                        {t("Check history")}
                    </button>
                    <button onClick={() => openReportProblemDialog()} className={classes.warningButton}>
                        {t("Report a problem")}
                    </button>
                </div>
                {props.workstation.selectedRecyclingWorkstationId !== 0 ?
                    <div className={classes.body}>
                        {selectedTab == "Stock" ?
                            <RegisterMaterial {...props} />
                            :
                            <WriteOffMaterial {...props} />
                        }
                    </div>
                    :
                    <div className={classes.body}>
                        <div className={classes.emptyStateContainer}>
                            <Recycle size={128} absoluteStrokeWidth strokeWidth={3} />
                            <p className={classes.emptyStateText}>{t("There are no recycling-stations selected")}</p>
                        </div>
                    </div>
                }
            </div>
            <ReportProblemDialog dialogOpen={reportProblemDialogOpen} loading={notificationSubmissionLoading} closeDialog={() => setReportProblemDialogOpen(false)} submitProblem={submitProblemNotification} actions={props.actions}></ReportProblemDialog>
        </>

    );
}

const useStyles = makeStyles({
    container: {
        width: '100%',
        position: "relative",
        top: "20px",
    },

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        position: "relative",

        padding: "0px 24px",

        marginBottom: "56px",
    },

    header__title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: "#0C0E29",

        margin: "0px",
    },

    sideBar: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        position: "absolute",
        right: "24px",
        top: "4px",

        padding: "8px",
        borderRadius: "6px",

        backgroundColor: "#F8F8F8",
        boxShadow: "0px 3px 16px rgba(175, 175, 175, 0.25)",
    },

    body: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },

    emptyStateContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "24px",

        marginTop: "360px",
        color: "#0C0E29",
    },

    emptyStateText: {
        fontSize: "24px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: "#0C0E29",
    },

    tabSlider: {
        display: "flex",
        backgroundColor: "#F8F8F8",
        borderRadius: "6px",
        width: "fit-content",

        position: "absolute",
        right: "50%",
        top: "50%",
        transform: "translate(50%, -50%)",

        marginBottom: "56px",
    },

    tabSlider__Indicator: {
        width: "144px",
        height: "48px",
        borderRadius: "6px",
        backgroundColor: "#4654FB",

        position: "absolute",
        transition: "transform 0.3s",
    },

    tabSlider__Tab: {
        width: "144px",
        height: "48px",

        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        backgroundColor: "transparent",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        padding: "0px",
        margin: "0px",

        zIndex: "1",

        transition: "color 0.3s",

        "&:hover": {
            color: "#4654FB",
        },

        "&.active": {
            color: "#F8F8F8",

            "&:hover": {
                color: "#F8F8F8",
            },
        }
    },

    secondaryButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",

        padding: "8px",
        paddingRight: "16px",

        boxSizing: "border-box",

        borderRadius: "3px",
        border: "1px solid #4654FB",
        backgroundColor: "transparent",
        color: "#4654FB",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        transition: "all 0.3s",

        "&:hover": {
            backgroundColor: "#3B3AF1",
            color: "#F8F8F8",

            cursor: "pointer",

            transition: "background-color 0.3s",
        },

        "&.disabled": {
            backgroundColor: "#DCDCDC",
            color: "#989898",
            cursor: "not-allowed",
        }
    },

    warningButton: {
        height: "40px",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",

        boxSizing: "border-box",

        borderRadius: "3px",
        border: "none",
        backgroundColor: "#F69127",
        color: "#F8F8F8",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        transition: "all 0.3s",

        "&:hover": {
            backgroundColor: "#E76F0F",
            color: "#F8F8F8",

            cursor: "pointer",

            transition: "background-color 0.3s",
        },

        "&.disabled": {
            backgroundColor: "#DCDCDC",
            color: "#989898",
            cursor: "not-allowed",
        }
    }
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation
    }
}

export default connect(mapStateToProps)(RecyclePage);